import { SESSION_KEY_DEBUG } from '../lib/constants';
import { loadStorageData, saveStorageData } from '../lib/persistance/storage';

let isLoggerEnabled = false;

/**
 * Environment-sensitive logging. Non-production envs have logging enabled per default,
 * in production it can be enabled by adding a session storage parameter debug = true
 */
export const initLogger = () => {
	if (process.env.NODE_ENV !== 'production') {
		saveStorageData(SESSION_KEY_DEBUG, true);
	}
	isLoggerEnabled = !!loadStorageData(SESSION_KEY_DEBUG);
};

// tslint:disable-next-line:no-any
export const log = (message?: any, ...optionalParams: any[]) => {
	if (isLoggerEnabled) {
		// tslint:disable-next-line:no-console
		console.log(message, ...optionalParams);
	}
};
